import * as A from '../admin'
import {blockMeta} from '../meta'

export interface ImageBlockConfig extends A.BlockConfig {
  altText: string
  imageUrl: string
  linkUrl: string
  tizraId: string
  width: 'bleed' | 'contain'
  maxWidth: string
  maxHeight: string
  fitting: 'contain' | 'cover' | 'scale-down'
  position: A.Justification
  focus: A.CompassDirection
}

const defaultConfig: ImageBlockConfig = {
  altText: '',
  imageUrl: '',
  linkUrl: '',
  tizraId: '',
  width: 'bleed',
  maxWidth: '',
  maxHeight: '',
  fitting: 'contain',
  position: 'left',
  focus: '',
  FREEMARKER: {
    altText: 'text',
    imageUrl: 'text',
  },
}

export const meta = blockMeta({
  name: 'image',
  displayName: 'ImageBlock',
  title: 'Image',
  defaultConfig,
})
